import { PLATFORM_ROUTES } from '@frontend/routing';
import { IconButton } from '@frontend/ui-elements';
import { useTheme } from '@mui/material';
import {
  BurgerDrawer,
  BurgerDrawerContainer,
  BurgerMenuBox,
  BurgerUserBox,
  BurgerUserMenuBox,
  GuestButtonWrapper,
} from './HeaderBurgerMenu.css';
import { HEADER_VARIANTS } from '../PlatformHeader.types';
import IHeaderBurgerMenu from './HeaderBurgerMenu.types';
import { RiCloseLine } from '@remixicon/react';
import { RiMenu4Fill } from '@remixicon/react';
import UserBox from '../UserBox/UserBox';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import UserMenu from '../UserMenu/UserMenu';
import {
  LoginButton,
  OpenVariantFormDrawerButton,
  SignUpButton,
} from '@customer-platform-shared/components/PlatformHeader/PlatformHeaderButtons';

export default function HeaderBurgerMenu({
  closeElement,
  isBurgerDrawerOpen,
  isLogoutModalOpen,
  openBurgerDrawer,
  openFormDrawer,
  openLogoutModal,
  switchOperationMode,
  openProfileDrawer,
  variant,
}: IHeaderBurgerMenu) {
  const { pathname } = useLocation();
  const pathnameIsLogin = pathname === PLATFORM_ROUTES.login;
  const theme = useTheme();
  const intl = useIntl();

  return (
    <>
      {isBurgerDrawerOpen ? (
        <IconButton
          id="user-header.icon-button.close-burger"
          aria-label={intl.formatMessage({
            id: 'customer-platform.header.user.menu.close',
          })}
          onClick={closeElement}
        >
          <RiCloseLine size={24} color={theme.palette.neutral[500]} />
        </IconButton>
      ) : (
        <IconButton
          id="user-header.icon-button.open-burger"
          data-testid="user-dropdown-button"
          aria-label={intl.formatMessage({
            id: 'customer-platform.header.user.menu.open',
          })}
          onClick={openBurgerDrawer}
        >
          <RiMenu4Fill size={'24px'} color={theme.palette.neutral[500]} />
        </IconButton>
      )}

      <BurgerDrawer
        anchor="right"
        onClose={closeElement}
        open={isBurgerDrawerOpen || isLogoutModalOpen}
      >
        <BurgerDrawerContainer>
          {[HEADER_VARIANTS.BUYER, HEADER_VARIANTS.SELLER].includes(
            variant,
          ) && (
            <>
              <BurgerUserMenuBox>
                <BurgerUserBox>
                  <UserBox variant={variant} />
                </BurgerUserBox>
                <BurgerMenuBox>
                  <UserMenu
                    variant={variant}
                    switchOperationMode={switchOperationMode}
                    openProfileDrawer={openProfileDrawer}
                    openLogoutModal={openLogoutModal}
                  />
                </BurgerMenuBox>
              </BurgerUserMenuBox>
              <OpenVariantFormDrawerButton
                variant={variant}
                openFormDrawer={openFormDrawer}
              />
            </>
          )}

          {variant === HEADER_VARIANTS.GUEST && (
            <GuestButtonWrapper>
              {pathnameIsLogin ? <SignUpButton /> : <LoginButton />}
            </GuestButtonWrapper>
          )}
        </BurgerDrawerContainer>
      </BurgerDrawer>
    </>
  );
}
